<template lang="pug">
  div
    //---------------------------------------
    //- CASH ASSETS
    //---------------------------------------
    .mar_t--30    
      .text__uppercase.text--size_14
        strong Cash (by Trading account)

      table.newtable.break-lg.mar_t--10
        thead.align__center
          tr
            td.align__left Currency
            td Total
            td MYR Total
            td %
        tbody.align__center
          template(v-for="account in cash")
            tr(v-for="currency in account.currencyTrustBalanceDtos")
              td(data-label="Currency").align__left: span {{ currency.currency }}
              td(data-label="Total"): span {{ currency.balance | twoDecimal }}
              td(data-label="MYR Total"): span {{ currency.myrBalance | twoDecimal }}
              td(data-label="%"): span {{ currency.pctOfTotal | twoDecimal }}
        
      .mar_t--15(v-if="!hasCash")
        MessageBar(type="warning") You have no cash assets 


    //---------------------------------------
    //- TABLE :: SHARES ASSETS
    //---------------------------------------
    .mar_t--40.mar_b--10
      .text__uppercase.text--size_14
        strong Shares (by CDS account)

      table.newtable.break-lg.mar_t--10
        thead.align__center
          tr
            td.align__left CDS Number
            td Total
            td MYR Total
            td %
        tbody.align__center
          tr(v-for="cds in shares")
            td(data-label="CDS Number").align__left: span {{ cds.cdsNumber }}
            td(data-label="Total"): span {{ cds.cdsMarketValue | twoDecimal }}
            td(data-label="MYR Total"): span {{ cds.cdsMarketValue | twoDecimal }}
            td(data-label="%"): span {{ cds.pctOfTotal | twoDecimal }}

      .mar_t--15(v-if="!hasShares")
        MessageBar(type="warning") You have no shares assets 

</template>




<script>
  import MessageBar from '@/components/MessageBar';
  import allFilters from '@/lib/filters';

  export default {
    props: {
      cash: {
        type: Array,
        required: true
      },
      shares: {
        type: Array,
        required: true
      },
    },


    components: {
      MessageBar
    },


    computed: {
      hasCash() {
        return this.cash.length > 0;
      },
      hasShares() {
        return this.shares.length > 0;
      }
    },


    filters: {
      twoDecimal: allFilters.twoDecimal,
    },    
  }
</script>

